import styles from './Slider.module.css';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

import React from 'react'
import { Container, Col, Carousel, Card, Button } from 'react-bootstrap';
import slider1 from '../../assets/imgs/slide1.png';
import slider2 from '../../assets/imgs/slide2.png';
import slider3 from '../../assets/imgs/slide3.png';
import vec from '../../assets/icons/vec2.png';

const responsive1 = {
    0: { items: 1 },
    568: { items: 1 },
    1024: { items: 1},
};

const items = [
    <div className="item" data-value="1">
    <img src={slider1} alt='slider 1' className={`img-fluid ${styles.slider1}`} />
    <Card.Footer className={`${styles.aFooter1}`}>
    <p><a href='' className={` ${styles.a}`}>Visit site</a> <img src={vec} /></p>
</Card.Footer>
    </div>,
    <div className="item" data-value="2"> 
       <img src={slider2} alt='slider 1' className={`img-fluid ${styles.slider1}`} />
<Card.Footer className={`${styles.aFooter2}`}>
                <p><a href='' className={`${styles.a}`}>Visit site</a> <img src={vec} /></p>
            </Card.Footer>
     </div>,
    <div className="item" data-value="3">  
       <img src={slider3} alt='slider 1' className={`img-fluid ${styles.slider1}`} />
       <Card.Footer className={`${styles.aFooter3}`}>
                        <p><a href='' className={`${styles.a}`}>Visit site</a> <img src={vec} /></p>
                    </Card.Footer>
     </div>,
    
  
  ];

export const Slider = () => {
  return (
    <div>
        <Container  className={`${styles.sliderr}`} >
            
          <AliceCarousel
                            autoPlay
                            autoPlayControls
                            autoPlayStrategy="none"
                            autoPlayInterval={3000}
                            infinite
                            mouseTracking
                            items={items}
                            responsive={responsive1}
                            controlsStrategy="alternate"
                            disableButtonsControls
                            disableSlideInfo
                        />
                        </Container>

      
    </div>
  )
}
